import React from "react";
import { AlertTriangle } from "lucide-react";

export function AvvisoOSS({ className = "" }) {
  return (
    <div className={`flex items-start gap-3 rounded-xl border-2 border-red-300 bg-red-50 px-4 py-3 ${className}`} data-testid="avviso-oss" role="alert">
      <AlertTriangle size={20} className="text-red-600 shrink-0 mt-0.5" />
      <p className="text-sm sm:text-base font-semibold text-red-700"><b>Attenzione:</b> il personale OSS può supervisionare e monitorare che gli ospiti prendano o meno le terapie prescritte dal medico, ma non può somministrarle.</p>
    </div>
  );
}
